import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { Flex } from '@repo/ui/Flex';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogHeader.module.css';

export type DialogHeaderProps = ComponentPropsWithoutRef<'header'> & {
  className?: string;
};

export const dialogHeaderVariants = cva(s.header, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogHeader = (props: DialogHeaderProps) => {
  const { children, className, ...attrs } = props;
  const { variant } = useDialog();

  return (
    <Flex
      as="header"
      alignItems="center"
      justifyContent="space-between"
      shrink="0"
      className={clsx(dialogHeaderVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </Flex>
  );
};
